import React from 'react'
import { Button } from '@/components/Button/Button'

export const TwoButtons = ({ onNextStep }: { onNextStep: any }) => {
  return (
    <div className="flex gap-2.5">
      <Button className="max-w-full w-full" onClick={onNextStep} variant="large">
        No
      </Button>
      <Button className="max-w-full w-full" onClick={onNextStep} variant="largeFill">
        Yes
      </Button>
    </div>
  )
}
